module.exports = __webpack_public_path__ + "img/STREAMER_TANGVE.c7bcfe6b.jpg";